"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.enumCast = exports.isInEnum = void 0;
const defLib = require("./def");
function isInEnum(enumType, enumValue) {
    return Object.values(enumType).includes(enumValue);
}
exports.isInEnum = isInEnum;
function enumCast(enumType, arg, def) {
    return defLib.enumCast(enumType, arg, def);
}
exports.enumCast = enumCast;
//# sourceMappingURL=enums.js.map